const privacyPolicyHref = `${window.location.origin}/privacy-policy`;

const quickQuoteForm = document.getElementById('quickQuote');

if (quickQuoteForm !== undefined) {

  const privacyPolicy = quickQuoteForm.querySelector('.freeform-input[name="privacyPolicy"]');

  if (privacyPolicy !== undefined) {

    const label = privacyPolicy.parentElement;

    let text = label.innerText;

    const anchor = `<a href="${privacyPolicyHref}">Privacy Policy</a>`
    const newText = text.replace(/(Privacy Policy)/gi, anchor);

    const span = document.createElement('span');
    span.innerHTML = newText;

    label.innerHTML = label.innerHTML.replace(text, '')

    if (newText !== text) label.appendChild(span);
  }
}